import React, { PureComponent } from 'react';
import { Text, TextPreset, ShadeColor, Color } from '@pegasus/ui-components/components/text';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import { injectConfig } from '@client/hoc/config';
import { getHasAccessibleOrange } from '@client/redux/modules/abtesting/accessibleOrange/selectors';
import FormatPrice from '@client/components/shared/FormatPrice';
import Translate from '@client/components/shared/translation/Translate';
import {
    ARTICLE_PRICE_SUPERSCRIPT,
    ARTICLE_PRICE_SUPERSCRIPT_RRP,
    ARTICLE_STATUS_RESERVED,
} from '@client/config/constants';
import {
    AvailabilityBadge,
    ReservedPopover,
} from '@client/components/shared/Shared';
import styles from './styles.scss';

export class Recommendation extends PureComponent {
    static propTypes = {
        campaignIdentifier: PropTypes.string.isRequired,
        brand: PropTypes.string.isRequired,
        stockStatus: PropTypes.string.isRequired,
        sku: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        specialPrice: PropTypes.number.isRequired,
        image: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        source: PropTypes.number.isRequired,
        position: PropTypes.number.isRequired,
        newCardStyle: PropTypes.bool,
        accessibleOrange: PropTypes.bool,
    };

    state = {
        reservedOnClick: false,
    };

    renderInfoBox = newCardStyle => {
        const {
            brand,
            price,
            specialPrice,
            similarPrices,
            accessibleOrange
        } = this.props;

        const hasMultiplePrices = (typeof similarPrices !== 'undefined') && !similarPrices;

        if (newCardStyle) {
            return (
                <div styleName="info--newCardStyle">
                    <p styleName="title">
                        <Text preset={TextPreset.XS_BOLD} color={Color.dark}>
                            {brand}
                        </Text>
                    </p>
                    <div styleName="price">
                        <Text preset={TextPreset.XXS} color={ShadeColor.dark60} >
                            <Translate message="recommendations.regularPriceShort" />{' '}
                            <del>
                                <FormatPrice price={price} />
                            </del>
                        </Text>
                        <div styleName="price-values">
                            <Text preset={TextPreset.XS_BOLD} color={accessibleOrange ? Color.primary : Color.brand}>
                                {hasMultiplePrices && (
                                    <Translate message="recommendations.differentPricePrefix" html />
                                )}
                                <FormatPrice
                                    price={specialPrice}
                                    superscript={ARTICLE_PRICE_SUPERSCRIPT}
                                />
                            </Text>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div styleName="info">
                <p styleName="title">
                    <Text preset={TextPreset.XXS_BOLD} color={Color.dark}>
                        {brand}
                    </Text>
                </p>
                <div styleName="price">
                    <Text preset={TextPreset.XXS} color={ShadeColor.dark60}>
                        <Translate message="recommendations.regularPriceShort" />
                    </Text>
                    <div styleName="price-values">
                        <Text preset={TextPreset.XXS} color={ShadeColor.dark60}>
                            <del>
                                <FormatPrice price={price} />
                            </del>{' '}
                            <sup>{ARTICLE_PRICE_SUPERSCRIPT_RRP}</sup>
                        </Text>
                        <div styleName="special-price-value">
                            <Text preset={TextPreset.XXS_BOLD} color={Color.dark}>
                                <FormatPrice
                                    price={specialPrice}
                                    superscript={ARTICLE_PRICE_SUPERSCRIPT}
                                />
                            </Text>
                        </div>
                    </div>
                </div>
            </div>
        );

    }

    render() {
        const {
            source,
            campaignIdentifier,
            sku,
            imageUrl,
            stockStatus
        } = this.props;

        return (
            <a
                onClick={this.onRecoClick}
                key={sku}
                id={`reco-${sku}`}
                styleName="wrapper"
                href={`/campaigns/${campaignIdentifier}/articles/${sku}${
                    source ? `?reco=${source}` : ''
                }`}
            >
                <div styleName="image-wrapper">
                    <div styleName="image">
                        <img src={imageUrl} />
                    </div>
                    {stockStatus === ARTICLE_STATUS_RESERVED && (
                        <AvailabilityBadge
                            stockStatus={stockStatus}
                            handleClick={this.handleClick}
                        />
                    )}
                </div>
                {this.state.reservedOnClick && (
                    <ReservedPopover handleClick={this.handleClick} />
                )}
                {this.renderInfoBox(this.props.newCardStyle)}
            </a>
        );
    }

    onRecoClick = e => {
        this.props.onClick(e, this.props.sku);
    };

    handleClick = event => {
        event.preventDefault();
        this.setState({ reservedOnClick: !this.state.reservedOnClick });
    };
}

const mapStateToProps = (state) => ({
    accessibleOrange: getHasAccessibleOrange(state)
});

export default compose(
    connect(mapStateToProps),
    injectConfig,
    CSSModules(styles),
)(Recommendation);
